import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import './index.css';

if (process.env.NODE_ENV === 'production' && typeof window !== 'undefined') {
  // Глобально приглушаем шум в production, оставляя console.error для диагностики.
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
}

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Глобальная настройка HMR
if (module.hot) {
  module.hot.accept('./App.jsx', () => {
    // HMR hook
  });
}
